/* import __COLOCATED_TEMPLATE__ from './unprotected-attributes-warning.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntercomAttribute from 'embercom/models/attribute';

interface Args {
  usedAttributeArray: string[];
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class UnprotectedAttributesWarning extends Component<Signature> {
  @service declare attributeService: any;
  @service declare intl: any;

  get unprotectedAttributes() {
    let attributes = this.args.usedAttributeArray;
    return this.attributeService.attributes.filter(
      (attr: IntercomAttribute) =>
        attributes.includes(attr.identifier) && !attr.preventUpdateFromMessenger,
    );
  }

  get shouldShowWarning() {
    return this.unprotectedAttributes.length > 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Body::Sections::Request::UnprotectedAttributesWarning': typeof UnprotectedAttributesWarning;
    'workflow-connector/builder/body/sections/request/unprotected-attributes-warning': typeof UnprotectedAttributesWarning;
  }
}
